import {microtime} from 'utils'

const isTokenValid = (decodedToken = {}) => {
    return decodedToken.exp && (decodedToken.exp - microtime() > 0);
};

export default isTokenValid;